interface Publico {
  comVaga: number;
  suplentes: number;
}

interface Props {
  equipe: Publico;
  campista: Publico;
  legenda: string;
  aoClicar?: () => void;
}

function Linha({ rotulo, dados }: { rotulo: string; dados: Publico }) {
  return (
    <div className="min-w-0">
      <div className="flex items-baseline justify-between gap-2">
        <span className="truncate text-[13px] font-semibold text-foreground-700">{rotulo}</span>
        <span className="shrink-0 text-[20px] font-extrabold leading-none tabular-nums text-foreground-950">
          {dados.comVaga.toLocaleString('pt-BR')}
        </span>
      </div>
      <span className="mt-0.5 block text-[11px] leading-snug text-foreground-400">
        {dados.comVaga.toLocaleString('pt-BR')} com vaga
        {dados.suplentes > 0
          ? ` · ${dados.suplentes.toLocaleString('pt-BR')} suplentes`
          : ' · sem suplentes'}
      </span>
    </div>
  );
}

// Cartão "Inscritos" do acampamento: Equipe e Campistas lado a lado, nunca somados.
export default function TileInscritos({ equipe, campista, legenda, aoClicar }: Props) {
  const corpo = (
    <>
      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-50 text-primary-600">
        <i className="ri-user-line text-lg" />
      </span>
      <div className="mt-3 space-y-2.5">
        <Linha rotulo="Equipe" dados={equipe} />
        <div className="h-px w-full bg-background-100" />
        <Linha rotulo="Campistas" dados={campista} />
      </div>
      {legenda ? (
        <span className="mt-2 block text-[13px] leading-snug text-foreground-500">{legenda}</span>
      ) : null}
    </>
  );

  if (aoClicar) {
    return (
      <button
        type="button"
        onClick={aoClicar}
        className="block min-w-0 w-full cursor-pointer rounded-3xl bg-white p-4 text-left shadow-[0_6px_18px_rgba(20,25,60,.06)] transition-colors hover:bg-primary-50"
      >
        {corpo}
      </button>
    );
  }
  return (
    <div className="min-w-0 rounded-3xl bg-white p-4 shadow-[0_6px_18px_rgba(20,25,60,.06)]">
      {corpo}
    </div>
  );
}